import { Component, inject, model } from '@angular/core';

import { ModalService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-ok-modal',
  templateUrl: './ok-modal.component.html',
  styleUrl: './ok-modal.component.scss',
  imports: [SummaryTopComponent],
})
export class OkModalComponent {
  private readonly modalService = inject(ModalService);

  public readonly header = model<string>();
  public readonly message = model<string>();
  // A model so an opener can set it on the instance, as with ok-cancel-modal (quick-despatch-amendments: Close).
  public readonly okLabel = model($localize`Ok`);

  onOk() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
